import { pricelist } from "@/consts/pricelist";

export const usePricelist = () => {
    const getPlanItem = ({ currency, plan }) => {
        currency = currency.value || currency;
        return pricelist[currency][plan] || {};
    }

    const getPrice = ({ currency, period, plan }) => {
        const { price } = getPlanItem({ currency, period, plan })
        return price
    }

    const getPricePerMonth = price => {
        return Math.round(price / 12)
    }

    return {
        getPlanItem,
        getPrice,
        getPricePerMonth
    }
}